import React, {FC} from 'react';
import styled from 'styled-components';

import {flexCenter} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {getTeamsByNamespace} from '../../../../../store/data/teams/teamsSelectors';
import {maybeRenderDeduplicationIcon, renderFullTagName} from '../../../../common/dropdowns/tagDropdownItem';
import {renderHighlightedPart} from './inboxesSearchSuggestionsHelpers';

/*
 * Props.
 */

interface SearchSuggestionsDropdownTagItemLabelProps {
  fuzzyQuery: string;
  tag: TagModel;
  tagsPath: ReadonlyArray<TagModel>;
  shouldShowDeduplication?: boolean;
}

/*
 * Style.
 */

const StyledTagItemLabelDiv = styled.div`
  ${flexCenter}
`;

/*
 * Component.
 */

export const SearchSuggestionsDropdownTagItemLabel: FC<SearchSuggestionsDropdownTagItemLabelProps> = (
  props,
) => {
  const {tag, tagsPath, fuzzyQuery, shouldShowDeduplication} = props;

  const teams = useAppSelector(getTeamsByNamespace);
  const team = teams[tag.namespace];

  const renderTagNameHighlights = (currentTag: TagModel) =>
    renderHighlightedPart(currentTag.name, undefined, fuzzyQuery);

  return (
    <StyledTagItemLabelDiv>
      {renderFullTagName(tag, tagsPath, false, undefined, renderTagNameHighlights)}
      {maybeRenderDeduplicationIcon(tag, team, shouldShowDeduplication)}
    </StyledTagItemLabelDiv>
  );
};
